import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Companion_getInstanceg4mecbw0mfx8 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
  ApolloGraphQLException2qazyzs4ebcad as ApolloGraphQLException,
  NoDataException34qvcinicy2ih as NoDataException,
} from '../exception/Exceptions.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation, requestUuid, data, errors, extensions, exception) {
        return new.target.t41(operation, requestUuid, data, errors, extensions, exception);
      }
      static t41(operation, requestUuid, data, errors, extensions, exception) {
        var $this = createThis(this);
        $this.l41_1 = operation;
        $this.m41_1 = requestUuid;
        $this.n41_1 = data;
        $this.o41_1 = errors;
        $this.p41_1 = extensions;
        $this.q41_1 = exception;
        $this.r41_1 = Companion_getInstance().b40_1;
        $this.s41_1 = false;
        return $this;
      }
      static u41(operation, requestUuid) {
        return this.t41(operation, requestUuid, null, null, null, null);
      }
      v41(executionContext) {
        // Inline function 'kotlin.apply' call
        this.r41_1 = this.r41_1.w41(executionContext);
        return this;
      }
      x41(data) {
        // Inline function 'kotlin.apply' call
        this.n41_1 = data;
        return this;
      }
      y41(errors) {
        // Inline function 'kotlin.apply' call
        this.o41_1 = errors;
        return this;
      }
      z41(exception) {
        // Inline function 'kotlin.apply' call
        this.q41_1 = exception;
        return this;
      }
      r40(extensions) {
        // Inline function 'kotlin.apply' call
        this.p41_1 = extensions;
        return this;
      }
      c40(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.m41_1 = requestUuid;
        return this;
      }
      a42(isLast) {
        // Inline function 'kotlin.apply' call
        this.s41_1 = isLast;
        return this;
      }
      i37() {
        var tmp1_operation = this.l41_1;
        var tmp2_requestUuid = this.m41_1;
        var tmp3_data = this.n41_1;
        var tmp4_executionContext = this.r41_1;
        var tmp0_elvis_lhs = this.p41_1;
        var tmp5_extensions = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
        var tmp6_errors = this.o41_1;
        var tmp7_exception = this.q41_1;
        var tmp8_isLast = this.s41_1;
        return new (ApolloResponse())(tmp2_requestUuid, tmp1_operation, tmp3_data, tmp6_errors, tmp7_exception, tmp5_extensions, tmp4_executionContext, tmp8_isLast);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloResponseClass;
function ApolloResponse() {
  if (ApolloResponseClass === VOID) {
    class $ {
      constructor(requestUuid, operation, data, errors, exception, extensions, executionContext, isLast) {
        this.b42_1 = requestUuid;
        this.c42_1 = operation;
        this.d42_1 = data;
        this.e42_1 = errors;
        this.f42_1 = exception;
        this.g42_1 = extensions;
        this.h42_1 = executionContext;
        this.i42_1 = isLast;
      }
      j42() {
        var tmp;
        if (this.x42()) {
          throw ApolloGraphQLException().w42(first(ensureNotNull(this.e42_1)));
        } else if (!(this.f42_1 == null)) {
          throw DefaultApolloException().p42('An exception happened', this.f42_1);
        } else {
          tmp = this.k42();
        }
        return tmp;
      }
      k42() {
        var tmp0_elvis_lhs = this.d42_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throw NoDataException().c43(this.f42_1);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      x42() {
        // Inline function 'kotlin.collections.isNullOrEmpty' call
        var this_0 = this.e42_1;
        return !(this_0 == null || this_0.n1());
      }
      j41() {
        return Builder().t41(this.c42_1, this.b42_1, this.d42_1, this.e42_1, this.g42_1, this.f42_1).v41(this.h42_1).a42(this.i42_1);
      }
      toString() {
        var tmp = 'operationName=' + this.c42_1.operationName() + ', ';
        var tmp_0 = 'data=' + (this.d42_1 == null ? 'null' : this.c42_1.operationName() + '.Data') + ', ';
        var tmp0_safe_receiver = this.e42_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q2();
        var tmp_1 = 'errors=' + toString(tmp1_elvis_lhs == null ? 'null' : tmp1_elvis_lhs) + ', ';
        var tmp_2;
        if (this.f42_1 == null) {
          tmp_2 = 'null';
        } else {
          var tmp2_elvis_lhs = getKClassFromExpression(this.f42_1).j1();
          tmp_2 = tmp2_elvis_lhs == null ? 'true' : tmp2_elvis_lhs;
        }
        return 'ApolloResponse(' + tmp + tmp_0 + tmp_1 + ('exception=' + tmp_2) + ')';
      }
    }
    initMetadataForClass($, 'ApolloResponse');
    ApolloResponseClass = $;
  }
  return ApolloResponseClass;
}
//region block: exports
export {
  Builder as Builder16nv925388a0q,
};
//endregion

//# sourceMappingURL=ApolloResponse.mjs.map
